import { gql } from '@apollo/client'

export const AI_COLLECTION_LIST = gql`
  query aiCollectionList(
    $first: Int
    $offset: Int
    $param: AiCollectionListParam
    $simplify: Boolean = false
  ) {
    aiCollectionQuery {
      list(page: { first: $first, offset: $offset }, param: $param) {
        edges {
          node {
            aiArtworkCount @skip(if: $simplify)
            collectionName
            id
            visible
            top
            coverAiArtworks @skip(if: $simplify) {
              id
              miniArtWorkUrl
            }
            squarePost @skip(if: $simplify) {
              id
            }
          }
        }
        pageInfo {
          totalCount
          hasNextPage
        }
      }
    }
  }
`

export const ADD_COLLECTION = gql`
  mutation addCollection($input: CreateCollectionInput!) {
    aiCollectionMutation {
      id: createCollection(input: $input)
    }
  }
`

export const DEL_COLLECTION = gql`
  mutation delCollection($ids: [ID!]!) {
    aiCollectionMutation {
      status: delCollections(ids: $ids)
    }
  }
`

export const UPDATE_COLLECTION = gql`
  mutation updateCollection($input: ModifyCollectionInput!) {
    aiCollectionMutation {
      status: modifyCollection(input: $input)
    }
  }
`

export const REMOVE_AI_ARTWORK = gql`
  mutation removeAiArtwork($input: CollectionAiArtworkInput!) {
    aiCollectionMutation {
      status: removeAiArtwork(input: $input)
    }
  }
`

export const ADD_AI_ARTWORK = gql`
  mutation addAiArtwork($input: CollectionAiArtworkInput!) {
    aiCollectionMutation {
      status: addAiArtwork(input: $input)
    }
  }
`

export const AI_COLLECTION_DETAIL = gql`
  query aiCollectionDetail(
    $id: Long!
    $offset: Int
    $first: Int
    $param: AiArtworkQueryInput
  ) {
    aiCollectionQuery {
      details(param: { id: $id }) {
        id
        collectionName
        collectionContent
        aiArtworkCount
        visible
        owned
        squarePost {
          createTags {
            id
            name
            publishVisible
          }
        }
        coverAiArtworks {
          id
          miniArtWorkUrl
        }
        aiArtworks(page: { offset: $offset, first: $first }, param: $param) {
          edges {
            node {
              id
              artWorkUrl
              miniArtWorkUrl
              status
              involveYellow
              completePercent
              expectedSeconds
              width: length
              height: width
              riskControl {
                status
              }
              extend {
                # 是否上架到市场 已上架
                artworkLink
                # 是否参加大赛 已投稿
                competitionLink
                # 是否发布到广场 已发布
                squarePostLink
                squarePost {
                  id
                }
                copyrightArtwork {
                  id
                  type
                  status
                }
              }
              serviceStatus
              violationRefundStatus # 违规退还状态
            }
          }
          pageInfo {
            totalCount
            hasNextPage
          }
        }
      }
    }
  }
`

export const AI_COLLECTION_ARTWORK_DETAIL = gql`
  query aiCollectionArtworkDetail($aiArtworkId: Long!, $id: Long!) {
    aiCollectionQuery {
      openCollectionAiArtworkDetails(aiArtworkId: $aiArtworkId, id: $id) {
        id
        miniArtWorkUrl
        width: length
        height: width
        aiCollection {
          collectionName
        }
      }
    }
  }
`

export const EDIT_COLLECTION_COVER = gql`
  mutation editCollectionCover($input: CollectionMakeCoverInput!) {
    aiCollectionMutation {
      status: makeCover(input: $input)
    }
  }
`
export const USER_SQUARE_POST_PAGE = gql`
  query noteUserSquarePostPage(
    $first: Int
    $offset: Int
    $param: PostUserQueryInput
  ) {
    squareModule {
      userSquarePostPage(
        page: { first: $first, offset: $offset }
        param: $param
      ) {
        pageInfo {
          totalCount
          hasNextPage
        }
        edges {
          node {
            id
            type
            top
            status
            aiCollection {
              aiArtworkCount
              collectionName
              id
              visible
              coverAiArtworks {
                id
                miniArtWorkUrl
              }
            }
          }
        }
      }
    }
  }
`
export const COVER_IMAGE_DETECTION = gql`
  mutation coverImageDetection($input: ImageDetectionInput) {
    commonMutation {
      id: imageDetection(input: $input)
    }
  }
`

export const DELETE_CUSTOM_IMAGE = gql`
  mutation deleteCustomImage($id: Long!) {
    aiCollectionMutation {
      success: delCustomCover(id: $id)
    }
  }
`

/** 合集置顶 */
export const AI_COLLECTION_TOP = gql`
  mutation aiCollectionTop($input: TopCollectionInput) {
    aiCollectionMutation {
      status: topCollection(input: $input)
    }
  }
`
